var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.token))])])}
var staticRenderFns = []

export { render, staticRenderFns }